<div
  appDialogTitle
  class="qr-code__dialog-header"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
>
  <span class="qr-code__dialog-header-title" cdkDragHandle>
    Scanner de QR Code
  </span>
  <app-button size="circle-small" (click)="close()">
    <app-icon>close</app-icon>
  </app-button>
</div>
<div appDialogContent class="qr-code">
  <div class="dialog-text mb-16">Digite o código para validar o QR code</div>

  <div class="dialog-row">
    <app-form-field color="primary" appearance="outline" required>
      <app-label>Código</app-label>
      <app-input placeholder="Código" [formControl]="secret"></app-input>
      <app-error *ngIf="secret.hasError('required')">
        Campo obrigatório
      </app-error>
      <app-error *ngIf="secret.hasError('wrongSecret')">
        Código incorreto
      </app-error>
      <app-error *ngIf="secret.hasError('downloadError')">
        Não foi possível fazer download do PDF original
      </app-error>
      <app-error *ngIf="errorMessage">{{ errorMessage }}</app-error>
    </app-form-field>
    <app-button
      size="icon"
      (click)="submit()"
      [disabled]="loading"
      [isLoading]="loading"
    >
      <app-icon *ngIf="!loading">check</app-icon>
    </app-button>
  </div>

  <div class="dialog-row">
    <div class="dialog-link">
      <div>Ou valide manualmente</div>
      <div class="link-preview" (mousedown)="stopIt($event)">
        {{ data.qrCodeLink }}
      </div>
    </div>
    <app-button
      class="flex-shrink-0"
      classButton="flex-shrink-0"
      variant="ghost-primary"
      size="small"
      (click)="copyLinkToClipboard(data.qrCodeLink)"
    >
      <app-icon>content_copy</app-icon>
      Copiar link
    </app-button>
  </div>
</div>
